module.exports = __webpack_public_path__ + "img/6_20.1b5d575d.png";